// extracted by mini-css-extract-plugin
module.exports = {"success-wrapper":"Success_success-wrapper__2T7tx","success-sec":"Success_success-sec__M5OAP","info-txt":"Success_info-txt__IItAQ","info-msg":"Success_info-msg__3cybr"};